import { h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { SupportedExportFormat } from '@/services/api/resources/analytics';
import { Dropdown } from '../controls/Dropdown';

type Callback = (format: SupportedExportFormat) => void;

export const exportDropdown = (input: Callback) => h(
  Dropdown,
  {
    props: {
      placeholder: t('common.export'),
      options: [
        {
          value: 'xls',
          label: t('form.export-xls'),
        },
        {
          value: 'csv',
          label: t('form.export-csv'),
        },
        {
          value: 'pdf',
          label: t('form.export-pdf'),
        },
      ],
      position: 'is-bottom-left',
      activable: false,
    },
    on: { input },
  },
);
